import React from "react";
import { Link } from "react-router-dom";
import Team from "../../api/team";

interface TeamMember {
  id?: string | number;
  tImg: string;
  slug: string;
  name: string;
  title: string;
}

interface TeamSectionProps {
  tClass?: string;
}
const ClickHandler = (): void => {
  window.scrollTo({ top: 10, behavior: "smooth" });
};

const TeamSection: React.FC<TeamSectionProps> = ({ tClass }) => {
  return (
    <section className={`wpo-team-section ${tClass || ""}`} style={{ padding: "100px 0", background: "rgba(10, 13, 20, 0.6)" }}>
      <div className="container">
        <div className="wpo-team-wrap">
          <div className="wpo-section-title text-center mb-60">
            <span className="sub-title" style={{ color: "#00ff97", fontWeight: 600, letterSpacing: "1px", textTransform: "uppercase" }}>
              Deep-Tech Leadership & Publications
            </span>
            <h2 className="poort-text poort-in-right" style={{ fontSize: "38px", color: "#ffffff", fontWeight: 700, marginTop: "12px" }}>
              Atlas Sync & Moduirum Core Research Team
            </h2>
            <p style={{ color: "#a0aec0", maxWidth: "800px", margin: "16px auto 0", fontSize: "16px", lineHeight: "1.7" }}>
              수학적 증명으로 메모리 한계를 지우는 O(1) 소버린 AI와 차세대 Physical AI 로보틱스 세상을 선도하는 대한민국 딥테크 핵심 연구진 및 《강화학습 실전 가이드》, 《생성형 AI & LLM 아키텍처》, 《Cursor AI 바이블》 5대 전문 저서 집필진.
            </p>
          </div>

          <div className="row justify-content-center">
            {Team.slice(0, 4).map((team: TeamMember, index: number) => (
              <div
                className="col col-lg-3 col-md-6 col-sm-6 col-12"
                key={team.id || index}
              >
                <div
                  className="wpo-team-item wow fadeInUp"
                  data-wow-duration="1200ms"
                  style={{
                    background: "rgba(26, 32, 44, 0.7)",
                    borderRadius: "16px",
                    padding: "20px",
                    border: "1px solid rgba(255, 255, 255, 0.08)",
                    textAlign: "center",
                    marginBottom: "30px",
                    transition: "transform 0.3s ease",
                  }}
                >
                  <div className="wpo-team-img-wrap" style={{ borderRadius: "12px", overflow: "hidden", marginBottom: "20px" }}>
                    <div className="wpo-team-img">
                      <div className="wpo-team-img-inner">
                        <img
                          src={team.tImg}
                          alt={team.name || "Team Member"}
                          loading="lazy"
                          style={{ width: "100%", height: "260px", objectFit: "cover", borderRadius: "12px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="wpo-team-text">
                    <h3 style={{ fontSize: "20px", fontWeight: 700, color: "#ffffff", marginBottom: "8px" }}>
                      <Link
                        onClick={ClickHandler}
                        to={`/team-single/${team.slug}`}
                        style={{ color: "#ffffff", textDecoration: "none" }}
                      >
                        {team.name}
                      </Link>
                    </h3>
                    <span style={{ color: "#00ff97", fontSize: "14px", fontWeight: 500 }}>{team.title}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
